export const COPY_TOOLTIP_ACTIVE_MS = 1500;
